export const FETCH_DOCUMENT_LIST_FOR_TASK_REQUEST = 'FETCH_DOCUMENT_LIST_FOR_TASK_REQUEST'
export const FETCH_DOCUMENT_LIST_FOR_TASK_SUCCESS = 'FETCH_DOCUMENT_LIST_FOR_TASK_SUCCESS'
export const FETCH_DOCUMENT_LIST_FOR_TASK_FALUIRE = 'FETCH_DOCUMENT_LIST_FOR_TASK_FALUIRE'
